import React, { useState } from "react";
import TeacherPanel from "../panel/TeacherPanel";
import { FaChalkboardTeacher } from "react-icons/fa";
import "../styles/JoinLiveClass.css";
import api from "../../../api/api";
const TeacherLiveClass = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
const [classes, setClasses] = useState([
  { id: 1, subject: "Maths", grade: "6", section: "A", status: "Scheduled", link: "", emoji: "📝" },
  { id: 2, subject: "Maths", grade: "6", section: "B", status: "Scheduled", link: "", emoji: "📝" },
  { id: 3, subject: "Maths", grade: "7", section: "A", status: "Scheduled", link: "", emoji: "📝" },
  { id: 4, subject: "Maths", grade: "7", section: "B", status: "Scheduled", link: "", emoji: "📝" },
  { id: 5, subject: "Maths", grade: "8", section: "A", status: "Scheduled", link: "", emoji: "📝" },
  { id: 6, subject: "Maths", grade: "8", section: "B", status: "Scheduled", link: "", emoji: "📝" },
  { id: 7, subject: "Maths", grade: "9", section: "A", status: "Scheduled", link: "", emoji: "📝" },
  { id: 8, subject: "Maths", grade: "9", section: "B", status: "Scheduled", link: "", emoji: "📝" },
  { id: 9, subject: "Maths", grade: "10", section: "A", status: "Scheduled", link: "", emoji: "📝" },
  { id: 10, subject: "Maths", grade: "10", section: "B", status: "Scheduled", link: "", emoji: "📝" },
]);


  const [selectedClass, setSelectedClass] = useState(null);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [newClassData, setNewClassData] = useState({ subject: "", grade: "", platform: "", date: "", time: "" });
  
  // New state for card-level notification
  const [notifyClassId, setNotifyClassId] = useState(null);

  const cardColors = ["#5c3dc4", "#ff6b6b", "#ffa500", "#4caf50", "#00bfff", "#e43972ff", "#81b348ff", "#9c27b0"];

  const handleScheduleChange = (e) => {
    setNewClassData({ ...newClassData, [e.target.name]: e.target.value });
  };

  const handleScheduleSubmit = (e) => {
    e.preventDefault();
    const newCls = {
      id: classes.length + 1,
      ...newClassData,
      status: "Scheduled",
      emoji: "📝",
      link: "",
    };
    setClasses([newCls, ...classes]);
    setScheduleModal(false);
    setNewClassData({ subject: "", grade: "", platform: "", date: "", time: "" });
  };

  const startClass = (clsId) => {
    setClasses(classes.map(c => c.id === clsId ? { ...c, status: "Live" } : c));
  };

  const endClass = (clsId) => {
    setClasses(classes.map(c => c.id === clsId ? { ...c, status: "Ended" } : c));
  };

  const shareLink = (clsId, platform) => {
    setClasses(classes.map(c => c.id === clsId ? { ...c, link: platform } : c));
    setSelectedClass(null);

    // Show notification over the card
    setNotifyClassId(clsId);
    setTimeout(() => setNotifyClassId(null), 3000);
  };

  return (
    <div className="page-container">
      <TeacherPanel onToggle={setIsSidebarCollapsed} />

      <div className={`join-live-content4 ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <div className="dashboard-topbar4">
          <span className="date-time">TODAY IS {new Date().toLocaleString()}</span>
          <span className="school-name">Semigon Learning ERP</span>
        </div>

        <h3 className="dashboard-title4">Manage Live Classes</h3>

        <div className="schedule-wrapper4">
          <button onClick={() => setScheduleModal(true)}>➕ Schedule New Class</button>
        </div>

        <div className="classes-grid4">
          {classes.map((cls, index) => (
            <div
              key={cls.id}
              className="class-card4"
              style={{ backgroundColor: cardColors[index % cardColors.length], position: "relative" }}
            >
              <div className="sr-left4">
                <div className="sr-label4">
                 {cls.emoji} {cls.subject} - Grade {cls.grade} Section {cls.section}

                </div>

                <div style={{ display: "flex", gap: "8px", marginTop: "5px" }}>
                  {cls.status === "Scheduled" && (
                    <>
                      <button onClick={() => startClass(cls.id)} className="sr-count4 live">Start</button>
                      <button onClick={() => { setSelectedClass(cls); }} className="sr-count4 upcoming">Share Link</button>
                      <button onClick={() => endClass(cls.id)} className="sr-count4 ended">End</button>
                    </>
                  )}

                  {cls.status === "Live" && (
                    <button onClick={() => endClass(cls.id)} className="sr-count4 live">End Class</button>
                  )}

                  {cls.status === "Ended" && (
                    <span className="sr-count4 ended">Ended</span>
                  )}
                </div>
              </div>
              <div className="sr-icon-chip4">
                <FaChalkboardTeacher />
              </div>

              {/* Card-level notification */}
              {notifyClassId === cls.id && (
                <div className="card-notify">
                  Students notified to join via {cls.link}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

{/* Schedule Modal */}
{scheduleModal && (
  <div className="join-modal-overlay4" onClick={() => setScheduleModal(false)}>
    <div className="join-modal4" onClick={(e) => e.stopPropagation()}>
      <h2>Schedule a Class</h2>
      <form onSubmit={handleScheduleSubmit}>
        {/* Subject input for Math teacher */}
        <label>
          Subject:
          <input
            type="text"
            name="subject"
            value="Maths"
            readOnly // cannot edit, always shows Maths
          />
        </label>

        {/* Grade dropdown */}
        <label>
          Grade:
          <select name="grade" value={newClassData.grade} onChange={handleScheduleChange} required>
            <option value="">Select Grade</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
        </label>

        {/* Section dropdown */}
        <label>
          Section:
          <select name="section" value={newClassData.section || ""} onChange={handleScheduleChange} required>
            <option value="">Select Section</option>
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
          </select>
        </label>

        {/* Date */}
        <label>
          Date:
          <input type="date" name="date" value={newClassData.date} onChange={handleScheduleChange} required />
        </label>

        {/* Time */}
        <label>
          Time:
          <select name="time" value={newClassData.time} onChange={handleScheduleChange} required>
            <option value="">Select Time</option>
            <option value="08:00">08:00 AM</option>
            <option value="09:00">09:00 AM</option>
            <option value="10:00">10:00 AM</option>
            <option value="11:00">11:00 AM</option>
            <option value="12:00">12:00 PM</option>
            <option value="13:00">01:00 PM</option>
            <option value="14:00">02:00 PM</option>
            <option value="15:00">03:00 PM</option>
          </select>
        </label>

        {/* Platform */}
        <label>
          Platform:
          <select name="platform" value={newClassData.platform} onChange={handleScheduleChange} required>
            <option value="">Select Platform</option>
            <option value="Google Meet">Google Meet</option>
            <option value="Microsoft Teams">Microsoft Teams</option>
            <option value="Zoom">Zoom</option>
          </select>
        </label>

        <button type="submit">Schedule Class</button>
        <button type="button" onClick={() => setScheduleModal(false)}>Cancel</button>
      </form>
    </div>
  </div>
)}


      {/* Share Link Modal */}
      {selectedClass && (
        <div className="join-modal-overlay4" onClick={() => setSelectedClass(null)}>
          <div className="join-modal4" onClick={(e) => e.stopPropagation()}>
            <h2>Share Link for {selectedClass.subject}</h2>
            <div className="join-links4" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <button onClick={() => shareLink(selectedClass.id, "Google Meet")} className="join-btn4 google">Google Meet</button>
              <button onClick={() => shareLink(selectedClass.id, "Microsoft Teams")} className="join-btn4 teams">Microsoft Teams</button>
              <button onClick={() => shareLink(selectedClass.id, "Zoom")} className="join-btn4 zoom">Zoom</button>
            </div>

            <button className="close-btn4" onClick={() => setSelectedClass(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeacherLiveClass;
